require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./dveloppement-et-communication-0-2-4.json") })
        }
      }, "path---dveloppement-et-communication-0-2-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---dveloppement-et-communication-0-2-4!./.cache/json/dveloppement-et-communication-0-2-4.json
// module id = 400
// module chunks = 231608221292675